import React from 'react';
import { FieldValues } from 'react-hook-form';
import { IntegratedFormContext, IntegratedForm } from './integrated-form-context';

export function useIntegratedForm<T extends FieldValues>(): IntegratedForm<T> {
    const integratedForm = React.useContext(IntegratedFormContext);
    if (!integratedForm) {
        throw new Error('Unexpectedly did not find IntegratedForm on context');
    }
    return integratedForm;
}
